import script from "./AddUserModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddUserModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddUserModal.vue?vue&type=style&index=0&id=44030df7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44030df7"]])

export default __exports__